export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_lable_product') || '产品',
    field: 'fabricColorTitle',
    width: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricColorTitle' },
  },
  {
    title: that.$l('table_lable_color_size') || '颜色尺寸',
    field: 'fabricColorSize',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricColorSize' },
  },
  {
    title: that.$l('table_lable_fabric_info') || '面料信息',
    field: 'fabricPosition',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricPosition' },
  },
  {
    title: that.$l('table_lable_spec_qty') || '规格数量',
    field: 'qty',
    width: 80,
    align: 'left',
    showHeaderOverflow: true,
  },
]
